import React from 'react';
import PropTypes from 'prop-types';
import { WriteReviewButton } from '@nexus/fff-ratings-and-reviews';

import styles from './ProductReviewCTA.module.scss';

const ProductReviewCTA = ({
  loggedIn,
  productHasReviewed,
  productHasReviews,
  ctaType,
  openReviewModal,
  isProductRatingSectionOpen,
  onClickCTALink,
  scrollToRef,
}) => {
  const CTA_TYPES = { link: 'link', button: 'button' };

  const getRatingCTAText = () => {
    let ctaText = '';
    if (loggedIn) {
      if (productHasReviews) {
        ctaText = productHasReviewed ? 'Read Reviews' : 'Write & Read Reviews';
      } else if (!productHasReviewed) {
        ctaText = 'Write a Review';
      }
    } else {
      ctaText = 'Read Reviews';
    }
    return ctaText;
  };

  const handleClickLink = () => {
    if (onClickCTALink !== null && !isProductRatingSectionOpen) {
      onClickCTALink();
    }

    scrollToRef.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  const getCtaEl = () => {
    if (ctaType === CTA_TYPES.link && typeof productHasReviewed === 'boolean') {
      return (
        <button type="button" className={styles.link} onClick={handleClickLink}>
          {getRatingCTAText()}
        </button>
      );
    }
    if (ctaType === CTA_TYPES.button) {
      if (!loggedIn || productHasReviewed) return null;
      return <WriteReviewButton onClick={openReviewModal} />;
    }
    return null;
  };

  return getCtaEl();
};

ProductReviewCTA.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  productHasReviewed: PropTypes.bool.isRequired,
  productHasReviews: PropTypes.bool.isRequired,
  ctaType: PropTypes.oneOf(['link', 'button']),
  openReviewModal: PropTypes.func,
  isProductRatingSectionOpen: PropTypes.bool,
  onClickCTALink: PropTypes.func,
  scrollToRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

ProductReviewCTA.defaultProps = {
  ctaType: 'link',
  isProductRatingSectionOpen: false,
  onClickCTALink: null,
  scrollToRef: null,
};

export default ProductReviewCTA;
